import { ScrollView } from 'devextreme-react';
import { createContext, useContext, useRef, useState } from 'react';
import './style.scss';
import BreadcrumbHeader from '../Header/BreadcrumbHeader';

WrapContent.defaultProps = {
  isShowBorder: true,
  isShowTitle: true,
};
const WrapContext = createContext({});

WrapContext.displayName = 'WrapContext';

export const useWrap = () => {
  const context = useContext(WrapContext);
  return context;
};

export default function WrapContent(props) {
  const [dataPage, setDataPage] = useState<any>(null);
  let top = 0;
  const scrollRef: any = useRef(null);

  /**
   * on scroll
   *
   * @param {*} e
   */
  const onScroll = e => {
    if (e?.reachedTop === true) {
      scrollRef.current.instance.scrollTo(top > 140 ? top : 0);
    } else {
      top = scrollRef.current.instance.scrollTop();
    }
  };

  /**
   * Custome set scroll to top
   *
   * @param {number} [position=0]
   */
  const setScrollTo = (position = 0) => {
    top = position;
    scrollRef.current.instance.scrollTo(top);
  };

  const value: any = {
    dataPage,
    setDataPage,
    setScrollTo,
  };
  return (
    <WrapContext.Provider value={value}>
      <main className="main-design">
        <ScrollView
          ref={scrollRef}
          onScroll={onScroll}
          useNative={true}
          height={'100%'}
        >
          <div>
            <BreadcrumbHeader />
            <div>{props.children}</div>
          </div>
        </ScrollView>
      </main>
    </WrapContext.Provider>
  );
}
